import { atom } from "recoil";
import { ICameraSystem } from "../types";

export const addStateCameraSystem = atom({
  key: "addStateCameraSystem",
  default: false,
});
export const editStateCameraSystem = atom({
  key: "editStateCameraSystem",
  default: false,
});
export const rowEditCameraSystem = atom<ICameraSystem | undefined>({
  key: "rowEditCameraSystem",
  default: undefined,
});

export const selectedRowsStateCameraSystem = atom<ICameraSystem[]>({
  key: "selectedRowsStateCameraSystem",
  default: [],
});

export const cameraSystemFilterText = atom({
  key: "cameraSystemFilterText",
  default: "",
});

export const cameraSystemFetching = atom({
  key: "cameraSystemFetching",
  default: true,
});

export const cameraSystemReFetching = atom({
  key: "cameraSystemReFetching",
  default: false,
});
